/**
 * «Ver más · quedan 1.240» — el final de una lista que se trae de a tandas.
 *
 * ⚠️ SE PIDE SOLO AL LLEGAR AL FINAL. El dueño lo quiso así: que al bajar
 * vayan saliendo todos. El botón queda por si el navegador no sabe avisar de
 * que se llegó abajo, y para quien prefiere tocarlo.
 *
 * Es la misma frase que el catálogo de la caja («Ver más · quedan N»): dos
 * formas de decir lo mismo en la misma app se leen como dos cosas distintas.
 */

import { useEffect, useRef } from "react";
import { cx } from "@/components/ui";

// Con el punto de los miles también en 4 cifras: «1.240», no «1240».
const CIFRA = new Intl.NumberFormat("es-VE", { useGrouping: "always" });

export function VerMas({
  quedan,
  onVerMas,
  cargando = false,
  alLlegar = true,
  className,
}: {
  quedan: number;
  onVerMas: () => void;
  cargando?: boolean;
  /** Pedir la siguiente tanda solo, cuando el botón aparece en pantalla. */
  alLlegar?: boolean;
  className?: string;
}) {
  const boton = useRef<HTMLButtonElement | null>(null);
  const pedir = useRef(onVerMas);
  pedir.current = onVerMas;

  useEffect(() => {
    const nodo = boton.current;
    if (!alLlegar || !nodo || typeof IntersectionObserver === "undefined") return;
    const vigia = new IntersectionObserver((entradas) => {
      if (entradas.some((e) => e.isIntersecting)) pedir.current();
    });
    vigia.observe(nodo);
    return () => vigia.disconnect();
    // Se vuelve a mirar con cada tanda: si tras cargar el botón sigue a la
    // vista (la lista era corta), se pide la siguiente.
  }, [alLlegar, quedan]);

  if (quedan <= 0) return null;

  return (
    <button
      ref={boton}
      type="button"
      onClick={onVerMas}
      disabled={cargando}
      className={cx(
        "block w-full px-3 py-2.5 text-center text-sm font-medium text-accent",
        "transition-colors hover:bg-surface-hover disabled:opacity-60",
        className,
      )}
    >
      {cargando ? "Cargando…" : `Ver más · quedan ${CIFRA.format(quedan)}`}
    </button>
  );
}
